<template>
  <!--批量搜索框s-->
  <el-dialog
    title="批量搜索"
    :visible.sync="batchSearchVisable"
    :close-on-click-modal="false"
    custom-class="batchSearch-custom-dialog"
  >
    <div class="dialog-fee-con">
      <el-radio-group v-model="batchSearchType">
        <el-radio :label="item.val" v-for="item in batchSearchTypeList" :key="item.val">{{ item.name }}</el-radio>
      </el-radio-group>
      <el-input class="mt-10" type="textarea" :rows="4" :placeholder="placeholder" v-model.trim="batchSearchVal">
      </el-input>
      <p v-if="batchSearchTypeErr" class="font-red">请选择搜索类型</p>
      <p v-if="!batchSearchTypeErr && batchSearchValErr" class="font-red">请输入批量搜索信息</p>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="handleBatchSearch">批量搜索</el-button>
    </div>
  </el-dialog>
  <!--批量搜索框e-->
</template>
<script>
export default {
  name: 'BatchSearch',
  props: {
    exportData: {
      type: Object
    },
    placeholder: {
      type: String,
      default: `批量输入搜索信息，信息用'、'或换行隔开；每次最多允许1000条(客户单号仅允许100条)`
    },
    batchSearchTypeOption: {
      type: [Number, String],
      required: false,
      default: ''
    },
    optionBatchSearchVal: {
      type: String,
      required: false,
      default: ''
    },

    batchSearchTypeList: {
      type: Array,
      default: () => [
        { val: 1, name: '车牌' },
        { val: 2, name: '司机手机' },
        { val: 3, name: '司机姓名' },
        { val: 4, name: '运单号' },
        { val: 5, name: '客户单号' }
      ]
    }
  },
  data() {
    return {
      batchSearchVisable: false,
      batchSearchTypeErr: false,
      batchSearchValErr: false,
      batchSearchVal: '', // 弹框批量搜索类型
      batchSearchType: '' //   弹框批量搜索值
    };
  },
  watch: {
    batchSearchType(val) {
      if (val) this.batchSearchTypeErr = false;
    },
    batchSearchVal(val) {
      if (val) this.batchSearchValErr = false;
    }
  },
  computed: {},
  methods: {
    openDia() {
      this.batchSearchVisable = true;
      this.batchSearchTypeErr = false;
      this.batchSearchValErr = false;
      this.batchSearchVal = this.optionBatchSearchVal || '';
      this.batchSearchType = this.batchSearchTypeOption || '';
    },
    handleBatchSearch() {
      if (!this.batchSearchType) {
        this.batchSearchTypeErr = true;
        return;
      }
      if (!this.batchSearchVal) {
        this.batchSearchValErr = true;
        return;
      }
      this.batchSearchVisable = false;
      this.$emit('bacthCallBack', {
        batchType: this.batchSearchType,
        batchValues: this.batchSearchVal,
        batchSearchValShow: `${this.batchSearchTypeList[this.batchSearchType - 1].name}:${this.batchSearchVal}`
      });
    }
  }
};
</script>

<style lang="postcss">
.batchSearch-custom-dialog {
  width: 536px;
  .el-radio {
    margin-bottom: 20px;
  }
}
</style>
